'use strict';
var firstPromise = new Promise(function(resolve, reject) {
    var timer = setTimeout(function() {
        reject(new Error('First promise was rejected'));
    }, 3000);
    document.addEventListener('click', function(e) {
        if (e.button === 0) {
            clearTimeout(timer);
            resolve('First promise was resolved');
        }
    });
});
var secondPromise = new Promise(function(resolve) {
    var handleClick = function(e) {
        if (e.button === 0) resolve('Second promise was resolved');
    };
    var rightClick = function(e) {
        e.preventDefault();
        if (e.button === 2) resolve('Second promise was resolved');
    };
    document.addEventListener('click', handleClick);
    document.addEventListener('contextmenu', rightClick);
});
var thirdPromise = new Promise(function(resolve) {
    var leftClicked = false;
    var rightClicked = false;
    document.addEventListener('click', function(e) {
        if (e.button === 0) leftClicked = true;
        if (leftClicked && rightClicked) resolve('Third promise was resolved');
    });
    document.addEventListener('contextmenu', function(ev) {
        ev.preventDefault();
        rightClicked = true;
        if (leftClicked && rightClicked) resolve('Third promise was resolved');
    });
});
function showNotification(msg) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'success';
    var message = document.createElement('div');
    message.setAttribute('data-qa', 'notification');
    message.classList.add(type);
    message.textContent = type === 'error' ? msg.message : msg;
    document.body.append(message);
}
firstPromise.then(function(m) {
    showNotification(m, 'success');
}).catch(function(e) {
    showNotification(e, 'error');
});
secondPromise.then(function(m) {
    showNotification(m, 'success');
});
thirdPromise.then(function(m) {
    showNotification(m, 'success');
});

//# sourceMappingURL=js_promises_practice_DOM.dab55f1a.js.map
